@let array = formArray();
@if (array) {
  <div [formGroup]="$any(array)" class="billing-page">

    <div class="header-row">
        <nb-icon pack="eva" icon="alert-circle-outline"></nb-icon>
        <span class="info-text">Jedes Gebäude kann mehrere Rechnungsadressen haben.</span>

      @if (!disabledSignal()) {
        <div class="header-actions">
          <button nbButton ghost status="primary" (click)="addBillingAddress()" nbTooltip="Adresse hinzufügen">
            <nb-icon pack="eva" icon="plus-outline"></nb-icon>
          </button>
        </div>
      }
    </div>

      @for (_ of controls(); track $index; let i = $index) {
        @if (!isDeleted(i)) {
          <div [formGroupName]="i" class="billing-item-wrapper">
            <nb-card class="billing-card">
              <nb-card-body>
                <div class="billing-components">

                  <div class="row">
                    <div class="recipient">
                      <label class="label">Empfänger</label>
                      <input fullWidth [id]="'recipient-' + i" type="text" nbInput formControlName="recipient" placeholder="Empfänger">
                    </div>
                  </div>

                  <div class="row">
                    <div class="address-line2">
                      <label class="label">Adresszusatz</label>
                      <input fullWidth [id]="'addressLine2-' + i" type="text" nbInput formControlName="addressLine2" placeholder="Adresszusatz">
                    </div>
                  </div>

                  <div class="row">
                    <div class="street">
                      <label class="label">Straße</label>
                      <input fullWidth [id]="'street-' + i" type="text" nbInput formControlName="street" placeholder="Straße">
                      @if (hasError(i, 'street')) { <div class="error">Pflichtfeld</div> }
                    </div>

                    <div class="number">
                      <label class="label">Hausnummer</label>
                      <input fullWidth [id]="'number-' + i" type="text" nbInput formControlName="number" placeholder="Nr">
                      @if (hasError(i, 'number')) { <div class="error">Pflichtfeld</div> }
                    </div>

                    <div class="uid">
                      <label class="label">UID</label>
                      <input fullWidth [id]="'uid-' + i" type="text" nbInput formControlName="uid" placeholder="UID">
                    </div>
                  </div>

                  <div class="row">
                    <div class="automatic-address">
                      <wr-automatic-address formControlName="automaticAddress"></wr-automatic-address>
                    </div>
                  </div>

                </div>
              </nb-card-body>
            </nb-card>

            @if (!disabledSignal()) {
              <div class="actions-container">
                <button nbButton ghost status="primary" (click)="deleteBillingAddress(i)" nbTooltip="Löschen">
                  <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                </button>
              </div>
            }
          </div>
        }
      }
  </div>
}
